import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Redirect, withRouter } from 'react-router-dom'
import { Collapse, message } from 'antd'
import AdminLayout from '../../components/AdminLayout'
import SectionHeader from '../../components/SectionHeader'
import SectionHeaderTemplate from '../../components/SectionHeaderTemplate'
import SectionContent from '../../components/SectionContent'
import Spin from '../../components/Spin'
import Form from './Form'
import ButtonMenuForm from './ButtonMenuForm'
import {
  editForm,
  fetchItem,
  createItem,
  editItem,
  deleteItem,
  reset,
} from '../../actions/roleForm'
import {
  fetchItems as fetchButtonMenuItems,
  editButtonMenuForm,
  editItem as editButtonItem,
  reset as resetButtonMenu,
} from '../../actions/roleButtonMenuForm'

import './index.less'

const { Panel } = Collapse

const listPath = '/admin/roles'
const itemsTitle = 'Роли'
const itemTitle = 'ролями'
const itemTitleCreate = 'роли'
const storeKey = 'roleForm'
const storeButtonMenuKey = 'roleButtonMenuForm'

class ItemForm extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleFormOnSubmit = this.handleFormOnSubmit.bind(this)
    this.handleFormOnDelete = this.handleFormOnDelete.bind(this)

    this.state = { activeKeyPanel: '0', role: this.props.match.params.itemId }

    this.props.reset()
  }

  componentDidMount() {
    if (this.props.type === 'edit') {
      this.props.fetchItem({ id: this.props.match.params.itemId })
      this.props.fetchButtonMenuItems({ f_role: this.props.match.params.itemId })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isCreateItemLoading && nextProps.isCreateItemSuccess) {
      message.success('Новая роль успешно создана.')
    } else if (this.props.isEditItemLoading && nextProps.isEditItemSuccess) {
      message.success('Данные роли успешно изменены.')
    } else if (this.props.isDeleteItemLoading && nextProps.isDeleteItemSuccess) {
      message.success('Роль успешно удалена.')
    } else if (this.props.isCreateItemLoading && nextProps.createItemError) {
      message.error(nextProps.createItemError)
    } else if (this.props.isEditItemLoading && nextProps.editItemError) {
      message.error(nextProps.editItemError)
    } else if (this.props.isDeleteItemLoading && nextProps.deleteItemError) {
      message.error(nextProps.deleteItemError)
    } else if (this.props.isFetchItemLoading && nextProps.fetchItemError) {
      message.error(nextProps.fetchItemError)
    } else if (this.props.isEditButtonMenuItemLoading && nextProps.isEditButtonMenuItemSuccess) {
    // message.success('Параметр успешно изменен.')
    // this.setState({
    //   activeKeyPanel: "0"
    // });
    } else if (this.props.isEditButtonMenuItemLoading && nextProps.editButtonMenuItemError) {
      message.error(nextProps.editButtonMenuItemError)
    //* *********/
    }
  }

  handleFormOnSubmit(values) {
    if (this.props.type === 'create') {
      this.props.createItem(values)
    } else {
      const item = { ...this.props.item, ...values }
      this.props.editItem(item)
    }
  }

  handleFormOnDelete() {
    this.props.deleteItem({ id: this.props.match.params.itemId })
  }

  handleButtonMenuOnChange(idnum, values, data) {
    const item = {
      idnum, n_enable: values ? '1' : '0', f_button: data.f_button, f_role: data.f_role,
    }
    this.editButtonItem(item)
  }

  render() {
    const { type, isCreateItemSuccess, isDeleteItemSuccess } = this.props
    const { activeKeyPanel } = this.state

    const isCreateForm = type === 'create'
    const actionTitle = isCreateForm ? 'Создать' : 'Управление'
    // Add module/
    const handleChangeKeyPanel = (e) => {
      this.setState({
        activeKeyPanel: e,
      })
    }
    //* *********/
    if (isCreateItemSuccess || isDeleteItemSuccess) {
      return <Redirect to={listPath} />
    }
    return (
      <div>
        <AdminLayout>
          <SectionHeader>
            <SectionHeaderTemplate
              breadcrumbRoutes={[{ path: '/admin', title: 'Главная' }, { path: listPath, title: itemsTitle }, { title: actionTitle }]}
              title={`${actionTitle} ${isCreateForm ? itemTitleCreate : itemTitle}`}
            />
          </SectionHeader>
          {!isCreateForm && !this.props.isFetchItemLoading &&
            <Collapse className='custom-collapse' accordion bordered={false} onChange={e => handleChangeKeyPanel(e)} activeKey={activeKeyPanel}>
              <Panel className='custom-accordion-panel' header='Управление элементами меню' key='1'>
                <SectionContent>
                  {(!this.props.isFetchButtonMenuItemsLoading && this.props.items) &&
                    this.props.items.map((item, key) =>
                      (<ButtonMenuForm
                        key={key}
                        keyItem={key}
                        onFieldsChange={this.props.editButtonMenuForm}
                        formFieldValues={item}
                        onChange={this.handleButtonMenuOnChange}
                        isEditButtonMenuItemLoading={this.props.isEditButtonMenuItemLoading}
                        editButtonItem={this.props.editButtonItem}
                      />))}
                </SectionContent>
              </Panel>
            </Collapse>
          }
          <SectionContent>
            {
              this.props.isFetchItemLoading && <Spin />
            }
            {
              (isCreateForm || (!isCreateForm && this.props.item)) &&
              <Form
                onSubmit={this.handleFormOnSubmit}
                onDelete={this.handleFormOnDelete}
                onFieldsChange={this.props.editForm}
                formFieldValues={this.props.formFieldValues}
                isCreateItemLoading={this.props.isCreateItemLoading}
                isEditItemLoading={this.props.isEditItemLoading}
                isDeleteItemLoading={this.props.isDeleteItemLoading}
                type={this.props.type}
              />
            }
          </SectionContent>
        </AdminLayout>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const {
    formFieldValues,
    isFetchItemLoading,
    isEditItemLoading,
    isCreateItemLoading,
    isCreateItemSuccess,
    isEditItemSuccess,
    isDeleteItemLoading,
    isDeleteItemSuccess,
    item,
    fetchItemError,
    createItemError,
    editItemError,
    deleteItemError,
  } = state[storeKey]
  // Add module/
  const {
    items,
    formFieldButtonMenuValues,
    isFetchButtonMenuItemsLoading,
    fetchButtonMenuItemsError,
    isEditButtonMenuItemLoading,
    isEditButtonMenuItemSuccess,
    editButtonMenuItemError,
  } = state[storeButtonMenuKey]
  //* *********/
  return {
    isFetchItemLoading,
    formFieldValues,
    isEditItemLoading,
    isCreateItemLoading,
    isCreateItemSuccess,
    isEditItemSuccess,
    isDeleteItemLoading,
    isDeleteItemSuccess,
    item,
    fetchItemError,
    createItemError,
    editItemError,
    deleteItemError,
    // Add module/
    formFieldButtonMenuValues,
    isFetchButtonMenuItemsLoading,
    fetchButtonMenuItemsError,
    isEditButtonMenuItemLoading,
    isEditButtonMenuItemSuccess,
    editButtonMenuItemError,
    items,
    //* *********/
  }
}

const mapDispatchToProps = dispatch => ({
  createItem: params => dispatch(createItem(params)),
  editItem: params => dispatch(editItem(params)),
  fetchItem: params => dispatch(fetchItem(params)),
  deleteItem: params => dispatch(deleteItem(params)),
  editForm: formFieldsChange => dispatch(editForm(formFieldsChange)),
  reset: () => dispatch(reset()),
  // Add module/
  fetchButtonMenuItems: params => dispatch(fetchButtonMenuItems(params)),
  editButtonItem: params => dispatch(editButtonItem(params)),
  editButtonMenuForm: formFieldsChange => dispatch(editButtonMenuForm(formFieldsChange)),
  resetButtonMenu: () => dispatch(resetButtonMenu()),
  //* *********/
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ItemForm))



// WEBPACK FOOTER //
// src/containers/RoleForm/index.jsx